require('./accordionBody.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class AccordionBody extends React.Component {
    render() {
        const { children, id, isExpanded } = this.props;
        return (
            <div id={id} className={classNames('accordion-body', { 'is-expanded': isExpanded })}>
                {children}
            </div>
        );
    }
}

AccordionBody.propTypes = {
    children: PropTypes.any,
    id: PropTypes.string,
    isExpanded: PropTypes.bool,
};

AccordionBody.defaultProps = {
    id: '',
    isExpanded: false,
};

module.exports = AccordionBody;
